import { Dialog, makeStyles } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { ThemeContext } from "../../theme/ThemeContext";
import CancelButtons from "./CancelButtons";
import SubmitButtons from "./SubmitButtons";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "20px",
    backgroundColor: (props) =>
      props.darkMode ? "#0E2A41" : theme.palette.background.paper,
    color: (props) => (props.darkMode ? "#fff" : ""),
  },
}));

export default function DeleteDialogBox(props) {
  const { darkMode } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });

  const { onSubmit, children, onClose, ...other } = props;

  const handleClose = () => {
    props.onClose(false);
  };

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      {...props}
      onClose={(event, reason) => {
        // Prevent closing the dialog on backdrop click or escape key
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return; // Prevent closing
        }
      }}
      disableBackdropClick
      disableEscapeKeyDown
      BackdropProps={{
        style: {
          backdropFilter: "blur(5px)",
          // Adjust the opacity as needed
        },
      }}
    >
      <DialogTitle variant="h4">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        {props.Header}
      </DialogTitle>
      <Divider
        variant="middle"
        style={{
          background: darkMode
            ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
            : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
          height: "1px",
          opacity: 0.5,
        }}
      />

      <div
        style={{
          maxHeight: "60vh",
          overflowY: "auto",
          backgroundColor: darkMode ? "#0E2A41" : "#fff",

          paddingBottom: "8px",
          paddingTop: "16px",
          paddingRight: "24px",
          paddingLeft: "24px",
        }}
      >
        {props.children}
      </div>
      <DialogActions
        style={{
          justifyContent: "center",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <CancelButtons
          variant="contained"
          color="secondary"
          onClick={() => props.cancel()}
        >
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {props.cancelText}
          </Typography>
        </CancelButtons>
        <SubmitButtons variant="contained" onClick={onSubmit}>
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {props.acceptText}
          </Typography>
        </SubmitButtons>
      </DialogActions>
    </Dialog>
  );
}
